import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface RequireRoleProps {
  role: string;
  children: ReactNode;
}

/**
 * À imbriquer DANS un sous-arbre déjà couvert par ProtectedRoute (auth déjà
 * établie) — redirige vers "/" si le rôle courant ne correspond pas. N'est
 * pas la frontière de sécurité (le backend l'impose via RolesGuard) : évite
 * seulement d'afficher une page dont chaque appel API répondrait 403.
 */
export function RequireRole({ role, children }: RequireRoleProps) {
  const { role: userRole } = useAuth();

  if (userRole !== role) return <Navigate to="/" replace />;

  return <>{children}</>;
}
